// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__SJle8","spinner":"Spinner_spinner__7f16G","spin":"Spinner_spin__xyVYo"};